import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  channelRow: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: ({ depth }: { depth: number }) =>
      depth === 1 ? theme.palette.grey[300] : theme.palette.grey[100]
  },
  channelRowDisabled: { opacity: '50%' },
  channelName: {
    marginLeft: 8
  },
  arrowIconContainer: {
    position: 'absolute',
    right: 0
  }
}))

export default useStyles
